import { render, staticRenderFns } from "./AffiliateCommissionsList.vue?vue&type=template&id=ca6e02a6&"
import script from "./AffiliateCommissionsList.vue?vue&type=script&lang=js&"
export * from "./AffiliateCommissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports